module.exports = __webpack_public_path__ + "img/70100014.813b7ce3.png";